import React, { Component } from 'react';
import withBaseState from '../common/withBaseState';
import * as queryService from '../common/query.service';
import * as snackService from '../common/snack.service';
import { checkIfApiCallSuccess, debitNoteAPi } from '../common/base.api';
import tableConfig from './config';
import history from '../../utils/history';
import { DEBIT_NOTE_CREATE, DEBIT_NOTE_DETAILS } from '../../data/enums/Route';
import { DEBIT_NOTE_CONFIG } from '../common/domain.config';
import PageView from '../common/pagination/PageView';
import { BillingSnackBar } from '../../components/BillingMDC';
import { voucherEncoder } from '../../utils/miscellaneous';
import { TRANSACTION_TYPE } from '../../data/enums/enums';
import DebitNoteStyled from './DebitNoteStyled';
import {storeInLocalStorage ,fetchFromLocalStorage} from "../common/common";

class DebitNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        searchBox: false,
        filter: false,
      },
      snack: { ...snackService.snackParameters },
      queryParameters: {
        ...queryService.queryParameters,
        filter:{},
      },
      data: {
        list: [],
        total: 0,
      },
    };
    const { downloadList } = this.props;

    this.basePaginationService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.loadTableData,
      downloadList,
    );
    this.basePaginationService.resetFilter();
  }

  componentDidMount() {
    this.getFilterStateFromStorage();
  }
  setFilterStateInStorage = () => {
    const { queryParameters} = this.state;
    
    storeInLocalStorage(
      'FILTER',
      {
       queryParameters,
      },
      "DEBIT_NOTE"
    );
  };
  getFilterStateFromStorage = () => {
    const {queryParameters} =this.state;
    const localData = fetchFromLocalStorage('FILTER', "DEBIT_NOTE");
    this.setState(
      { queryParameters:localData?.queryParameters || queryParameters ,},
      () => {
        this.loadTableData();
      },
    );
  };
  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };

  loadTableData = () => {
    const { queryParameters } = this.state;
    const extraQuery = `&jv_transaction_type=[${TRANSACTION_TYPE.DEBIT_NOTE}]`;
    this.setFilterStateInStorage();
    debitNoteAPi.getList(queryParameters, extraQuery).then(response => {
      if (checkIfApiCallSuccess(response)) {
        const { data } = this.state;
        data.list = response.list;
        data.total = response.total;
        this.setState({ data });
      }
    });
  };

  handleFabButtonClick = () => {
    history.push(`/${DEBIT_NOTE_CREATE}`);
  };

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;
    this.setState(display);
  };

  closeSnack = () => {
    const snack = snackService.resetSnack();
    this.setState({ snack });
  };
  handleClearSearch =() =>{
    const {display}=this.state;
    this.setState({display:{...display,searchBox:false,search:false}});
    this.basePaginationService.clearSearchText();
  }
  handleTableBodyClick = id => {
    const voucherNumber = voucherEncoder(id) || '';
    history.push(`/${DEBIT_NOTE_DETAILS}/${voucherNumber}`);
  };

  render() {
    const { display, queryParameters, data, snack } = this.state;

    const { serverResponseWaiting } = this.props;

    return (
      <DebitNoteStyled>
        <div className="debit-note">
          <PageView
            domainConfig={DEBIT_NOTE_CONFIG}
            headerConfig={{
              search: true,
              date: true,
              upload: false,
              download: true,
              filter: true,
              create: true,
            }}
            controlDisplay={this.controlDisplay}
            serverResponseWaiting={serverResponseWaiting}
            resetFilter={this.basePaginationService.resetFilter}
            handleDateRangeChange={this.basePaginationService.handleDateRangeChange}
            handleDownloadClick={this.basePaginationService.handleDownloadClick}
            display={display}
            data={data}
            queryParameters={queryParameters}
            tableConfig={tableConfig}
            handleTableSorting={this.basePaginationService.handleTableSorting}
            onTableBodyClick={this.handleTableBodyClick}
            onPageSelect={this.basePaginationService.onPageSelect}
            handleFilterChange={this.basePaginationService.handleFilterChange}
            createHandler={this.handleFabButtonClick}
            handleSearchChange={this.basePaginationService.handleSearchInputChange}
            clearSearchText={this.handleClearSearch}
          />

          <BillingSnackBar closeSnack={this.closeSnack} config={snack} />
        </div>
      </DebitNoteStyled>
    );
  }
}

const DebitNoteWithState = withBaseState(DebitNote);

export default DebitNoteWithState;
